import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WorklogComponent } from '../components/worklog/worklog.component';

const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo: '',
  //   pathMatch: 'full',
  //   data: { title: 'Apollo - Order List' }
  // },
  {
    path: '',
    component: WorklogComponent,
    // canActivate: [AuthGuard],
    data: { title: 'Apollo - Worklog' }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WorklogRoutingModule { }
